// ** React Imports
import { useState } from 'react'

// ** Component Imports
import { InputChip } from './InputChip'

// ** Icon Imports
import { Mail } from '../../icons'

// ** Utility Imports
import { EMAIL } from '@/shared/lib'

// ** Styled Components
import {
	Container,
	StyledInput,
	MainContainer,
	FormLabelStyled,
	StartIconContainer
} from './styles'

interface Props {
	chips: string[]
	setChips: React.Dispatch<React.SetStateAction<string[]>>
	isError: boolean
	setIsError: React.Dispatch<React.SetStateAction<boolean>>
	value?: string
	setValue?: React.Dispatch<React.SetStateAction<string>>
	className?: string
}

export const ChipsInput = ({
	chips,
	setChips,
	isError,
	setIsError,
	value: propValue,
	setValue: propSetValue,
	...props
}: Props) => {
	const [value, setValue] = useState<string>(propValue ?? '')
	const [isFocused, setIsFocused] = useState<boolean>(false)

	const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
		if (e.code !== 'Enter' && e.code !== 'Space') return

		if (!value.trim()) return

		if (!EMAIL.test(value.trim())) {
			setIsError(true)
			return
		}

		const isChipAlreadyExists = chips.some((chip) => chip === value.trim())

		if (isChipAlreadyExists) {
			setIsError(true)
			return
		}
		setChips((prev) => [...prev, e.currentTarget.value.trim()])
		setValue('')
	}

	const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
		const enteredValue = e.currentTarget.value
		setValue(enteredValue)
		propSetValue?.(enteredValue)
		if ((EMAIL.test(enteredValue) && isError) || enteredValue === '')
			setIsError(false)
	}

	const removeChip = (chip: string): void => {
		setChips((prev) => prev.filter((prevChip) => prevChip !== chip))
	}

	return (
		<MainContainer {...props}>
			<StartIconContainer $isError={isError}>
				<Mail />
			</StartIconContainer>
			<Container
				$shouldLabelFloat={isFocused || !!chips.length || !!value}
				$isError={isError}
			>
				{chips.map((chip) => (
					<InputChip key={chip} chip={chip} onRemove={removeChip} />
				))}
				<StyledInput
					onFocus={() => {
						setIsFocused(true)
					}}
					onBlur={() => {
						setIsFocused(false)
					}}
					onKeyDown={handleKeyDown}
					onChange={handleChange}
					value={value}
				/>
			</Container>
			<FormLabelStyled>Email</FormLabelStyled>
		</MainContainer>
	)
}
